<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close(false)"></div>
      <div :class="{modalContent: true}">
        <div class="close" v-on:click="close(false)"></div>
        <h4 class="modalTitle">Embed</h4>
        <div class="shareLink" v-if="detail">
          {{embedCode}}
          <div class="copy" v-on:click="copyToClp(embedCode)">SALIN</div>
        </div>
      </div>
      <Snackbar ref="snackbar"/>
    </div>
  </transition>
</template>

<script>
import Snackbar from '@/components/Snackbar.vue';

export default {
  name: 'shareDialog',
  components: { Snackbar },
  data() {
    return {
      show: false,
      next: null,
      detail: null,
      embedCode: null,
    };
  },
  methods: {
    copyToClp(txt2copy) {
      const m = document;
      const txt = m.createTextNode(txt2copy);
      const w = window;
      const b = m.body;
      b.appendChild(txt);
      if (b.createTextRange) {
        const d = b.createTextRange();
        d.moveToElementText(txt);
        d.select();
        m.execCommand('copy');
      } else {
        const d = m.createRange();
        const g = w.getSelection;
        d.selectNodeContents(txt);
        g().removeAllRanges();
        g().addRange(d);
        m.execCommand('copy');
        g().removeAllRanges();
      }
      txt.remove();
      this.$refs.snackbar.open({ content: 'Embed code copied to clipboard.' });
    },
    open(d, next) {
      this.detail = d;
      const uri = `${this.$config.appUri}embed/${d.slug}`;
      this.embedCode = `<iframe width="560" height="315" src="${uri}" `
        + `title="${d.title}" frameborder="0" allow="accelerometer; autoplay; `
        + 'clipboard-write; encrypted-media; gyroscope; picture-in-picture" '
        + 'allowfullscreen></iframe>';
      this.show = true;
      this.next = next;
    },
    close(b, o) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, o);
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 40px 40px;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      box-sizing: border-box;
      max-width: 100%;
      width: 720px;
      @media (max-height: 680px) {
        padding: 30px 20px 100px;
        margin: 0; top: auto; bottom: 0;
        border-radius: 5px 5px 0 0;
      }
      .close{
        position: absolute;
        right: 6px; top: 6px;
        width: 40px; height: 40px;
        border-radius: 50%;
        background-image: url(../assets/close.png);
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .4;
        cursor: pointer;
        transition: all .2s ease;
        &:hover{
          background-color: #e9e9e9;
          opacity: .8;
        }
      }
      .modalTitle{
        padding: 20px 114px 10px;
        font-size: 28px;
        margin: -30px -80px 24px;
        background-color: #eee;
        @media (max-height: 680px) {
          background-color: #fff;
          margin: -30px 0 24px;
          font-size: 24px;
          padding: 20px 0 0;
        }
      }
      .shareDivider{
        margin: 20px 34px 10px;
        border-top: #eee 1px solid;
        @media (max-height: 680px) {
          margin: 20px 0 10px;
        }
      }
      .shareAt{
        margin: 0 34px;
        padding: 4px 0;
        padding-left: 28px;
        position: relative;
        cursor: pointer;
        @media (max-height: 680px) {
          margin: 0;
        }
        .checkbox{
          width: 14px; height: 14px;
          border: #999 2px solid;
          border-radius: 3px;
          position: absolute;
          left: 0; top: 4px;
          background-position: center;
          background-repeat: no-repeat;
          background-size: 14px auto;
          transition: all .3s ease;
          &.checked{
            background-color: #002f5f;
            border-color: #002f5f;
            background-image: url(../assets/checked.png);
          }
        }
        &:hover{
          .checkbox{
            border-color: #444;
            &.checked{
              border-color: #002f5f;
            }
          }
        }
      }
      .shareLink{
        margin: 20px 34px 0;
        background-color: #f5f5f5;
        border: #ccc 1px solid;
        border-radius: 3px;
        color: #222;
        padding: 10px 12px;
        position: relative;
        padding-right: 80px;
        @media (max-height: 680px) {
          margin: 20px 0 0;
        }
        .copy{
          position: absolute;
          right: 4px; top: 4px;
          font-weight: 600;
          color: #005ab5;
          padding: 6px 10px;
          border-radius: 3px;
          cursor: pointer;
          &:hover{
            background-color: #ddd;
          }
        }
      }
      .selectorCnt{
        display: flex;
        justify-content: center;
        @media (max-height: 680px) {
          justify-content: space-between;
        }
        .selectorItem{
          padding: 14px 34px 10px;
          border: #fff 1px solid;
          border-radius: 5px;
          transition: all .2s ease;
          position: relative;
          text-align: center;
          @media (max-height: 680px) {
            padding: 14px 10px 10px;
          }
          &:hover{
            opacity: 1;
            // border-color: #f5f5f5;
            // box-shadow: 2px 2px 2px rgba(0,0,0,.1);
            cursor: pointer;
            background-color: #f5f5f5;
          }
          h4{
            margin: 0;
            font-size: 14px;
            font-weight: 600;
          }
          img{
            height: 30px;
            margin-bottom: 5px;
          }
        }
      }
    }
  }
</style>
